module.exports = __webpack_public_path__ + "static/img/autogood2.30e385e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/autogood2.png
// module id = EHZA
// module chunks = 0